import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueI18n from "vue-i18n";
import i18n from "./plugins/i18n";
import permissions from "./plugins/permissions";

import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "./styles/styles.scss";
import GSignInButton from "vue-google-signin-button";
import LoaderHover from "./components/loaderHover/LoaderHover.vue";

Vue.use(VueI18n);
Vue.use(GSignInButton);
Vue.use(permissions);

Vue.component("LoaderHover", LoaderHover);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
